// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__rWISu","paragraphs":"style_paragraphs__AXJr2","moreInfo":"style_moreInfo__zbLBJ","showMore":"style_showMore__rYdGS"};